
import { CREATE_INVOICE } from '../../endpoints';
import { Invoice } from '../../types/invoice';
import makeAuthenticatedRequest from '../base-api';

interface CreateInvoiceResponse {
  success: boolean;
  message?: string;
  invoice?: Invoice;
}


const createInvoiceApi = async (payload: any): Promise<CreateInvoiceResponse> => {
  try {
    const response = await makeAuthenticatedRequest(CREATE_INVOICE, {
      method: 'POST',   
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result?.data;
  } catch (error) {
    console.error('Create invoice failed:', error);
    throw error;
  }
};

export { createInvoiceApi, type CreateInvoiceResponse };    
